import WidgetItem from './widget-item.component';
export default WidgetItem;
